import firebase from '@firebase/app'
import '@firebase/database'

const state = {
  progress: [],
  currentProgress: {
    progress: null,
    section: null,
    task: null
  },
  progressRef: null,
  progressLoaded: false
}

const getters = {
  progress (state) {
    return state.progress
  },
  currentProgress (state) {
    return state.currentProgress
  },
  progressRef (state) {
    return state.progressRef
  },
  progressLoaded (state) {
    return state.progressLoaded
  },
  progressByKey (state) {
    return (progressKey) => {
      return state.progress.find(p => {
        return p.key === progressKey
      })
    }
  },
  progressByCourse (state) {
    return (courseKey) => {
      let progress = []
      for (let p of state.progress) {
        if (p.courseKey === courseKey) progress.push(p)
      }
      return progress
    }
  },
  progressByStudent (state) {
    return (studentId) => {
      let progress = []
      for (let p of state.progress) {
        if (p.studentId === studentId) progress.push(p)
      }
      return progress
    }
  },
  progressByCourseByStudent (state) {
    return (courseKey, studentId) => {
      let progress = []
      for (let p of state.progress) {
        if (p.courseKey === courseKey && p.studentId === studentId) progress.push(p)
      }
      return progress
    }
  },
  progressByUrlByStudent (state) {
    return (progressUrl, studentId) => {
      return state.progress.find(p => {
        return (p.url === progressUrl) && (p.studentId === studentId)
      })
    }
  }
}

const mutations = {
  setProgress (state, payload) {
    state.progress = payload
  },
  setCurrentProgress (state, payload) {
    state.currentProgress = payload
  },
  setProgressRef (state, payload) {
    state.progressRef = payload
  },
  setProgressLoaded (state, payload) {
    state.progressLoaded = payload
  }
}

const actions = {
  loadProgress: (store) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('progress')
    ref.on('value', snapshot => {
      const progress = []
      snapshot.forEach(p => {
        progress.push({key: p.key, ...p.val()})
      })
      store.commit('setProgress', progress)
      store.commit('setProgressLoaded', true)
      store.commit('setProgressRef', ref)
      resolve()
    })
  }),
  resetProgressModule (store) {
    store.dispatch('resetProgress').then(() => {
      store.dispatch('resetContentProgress').then(() => {
        store.dispatch('resetSectionProgress').then(() => {
          store.dispatch('resetTaskProgress')
        })
      })
    })
  },
  setCurrentProgress (store, payload) {
    store.commit('setCurrentProgress', payload)
  },
  createProgress: (store, payload) => new Promise((resolve, reject) => {
    const newProgress = {...payload}
    store.getters.progressRef.push(newProgress).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  updateProgress: (store, payload) => new Promise((resolve, reject) => {
    const newProgress = {...payload}
    store.getters.progressRef.child(newProgress.key).set(newProgress).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  resetProgress: (store) => new Promise((resolve, reject) => {
    if (store.getters.progressRef) store.getters.progressRef.off()
    store.commit('setProgress', [])
    store.commit('setProgressRef', null)
    store.commit('setProgressLoaded', false)
    resolve()
  })
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/student/progress.js